import React from "react";
import Image from "../elements/Image";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

const OrderItem = ({ data }) => {
  // const statusHexColorMap = {
  //   Approved: "#4f46e5",
  //   Declined: "#fb923c",
  //   Fullfilled: "#06D6A0",
  //   Cancelled: "#ef427c",
  //   Awaiting: "#bc93e4",
  //   processing: "#4f46e5"

  // };
  const statusHexColorMap = {
    delivered: "#06D6A0",
    shipped: "#4f46e5",
    returnRequest: "#fb923c",
    returnConfirmed: "#06D6A0",
    pickup: "#06D6A0",
    pending: "#bc93e4",
    Cancelled: "#ef427c",
    Awaiting: "#bc93e4",
    processing: "#4f46e5",
    exchangeRequest: "#fb923c",
    exchangeConfirmed: "#06D6A0",
  };

  const statusDeliveryHexColorMap = {
    Awaiting: "#bc93e4",
    Processing: "#FFD166",
    "In Transit": "#fb923c",
    Delivered: "#06D6A0",
    Cancelled: "#ef427c",
  };
  // console.log(data, "ss");
  return (
    <Link
      to={`/orders/${data?.orderId}`}
      className="relative block z-0 overflow-hidden bg-white py-4 px-4 rounded-lg border border-md-pink-light-1 hover:shadow-md hover:shadow-md-pink/20 transition-all duration-300 hover:bg-md-pink-light-2"
      style={{
        // "--statusColor": statusHexColorMap[data?.status?.info],
        "--statusColor": statusHexColorMap[data?.status],
        // "--deliveryStatusColor":
        //   statusHexColorMap[data?.status?.info],
        "--deliveryStatusColor": statusHexColorMap[data?.status],
      }}
    >
      <div
        className="absolute top-1/2 left-0 h-full aspect-square z-[-1] -translate-y-1/2 -translate-x-1/2 rounded-full blur-xl opacity-10"
        style={{ backgroundColor: "var(--deliveryStatusColor)" }}
      />
      <div className="grid grid-cols-5 gap-4">
        <div className="col-span-3">
          {data?.bookData?.title && (
            <h2 className="text-lg 2xl:text-xl font-semibold text-md-dark">
              {data?.bookData?.title}
            </h2>
          )}
          {data?.bookData?.description && (
            <div className="text-sm text-slate-500 !leading-none mt-1 tracking-wide">
              {data?.bookData?.description}
            </div>
          )}
          {data?.items?.length > 0 && (
            <div className="mt-3 flex items-center -space-x-4">
              {/* {data?.collectionArray?.slice(0, 8).map((item, index) => ( */}
              {data?.items?.slice(0, 8).map((item, index) => (
                <div
                  key={index}
                  className="w-10 h-10 aspect-square flex-shrink-0 rounded-full overflow-hidden border-4 border-solid border-white flex relative"
                >
                  <Image
                    src={item?.media?.url || ""}
                    alt={item?.media?.filename || ""}
                    width={"100%"}
                    height={"100%"}
                    effect={"blur"}
                    classes={"object-cover"}
                  />
                </div>
              ))}
              {data?.items?.length > 8 && (
                <div className="w-6 h-6 aspect-square flex-shrink-0 rounded-full overflow-hidden border border-solid border-md-pink/10 bg-md-pink-light-1 flex items-center justify-center text-xs font-semibold text-md-pink relative">
                  {"+" + (data?.items?.length - 8)}
                </div>
              )}
            </div>
          )}
        </div>
        <div className="flex justify-end col-span-2">
          <div className="flex flex-col items-end justify-between gap-2">
            {/* {data?.status && (
              <div
                className="relative text-[10px] inline-flex items-center gap-x-1 leading-none uppercase py-1 px-1 rounded-full tracking-widest font-semibold"
                style={{ color: "var(--statusColor)" }}
              >
                <div
                  className="absolute top-0 left-0 w-full h-full rounded-xl opacity-10"
                  style={{ backgroundColor: "var(--statusColor)" }}
                />
                <div
                  className="absolute top-0 left-0 w-full h-full rounded-xl border opacity-10"
                  style={{ borderColor: "var(--statusColor)" }}
                />
                <div
                  className="w-3 h-3 rounded-full animate-pulse"
                  style={{ backgroundColor: "var(--statusColor)" }}
                />
                <span className="px-1">{data?.status?.info}</span>
              </div>
            )} */}
            {data?.createdAt && (
              <div className="text-sm text-slate-500">{data?.createdAt}</div>
            )}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 3xl:grid-cols-5 gap-4 mt-4 pt-4 border-t border-md-pink-light-1">
        <div className="col-span-1 space-y-0.5">
          <div className="text-[11px] 2xl:text-xs uppercase leading-none text-slate-400 tracking-wide">
            Order ID
          </div>
          <div className="text-sm 2xl:text-base font-medium leading-none">
            {data?.orderId}
          </div>
        </div>
        <div className="col-span-2 3xl:col-span-1 space-y-0.5">
          <div className="text-[11px] 2xl:text-xs uppercase leading-none text-slate-400 tracking-wide">
            {/* Transaction ID */}
            Invoice ID
          </div>
          <div className="text-sm 2xl:text-base font-medium leading-none">
            {/* {data?.transactionid} */}
            {data?.invoiceNumber}
          </div>
        </div>
        <div className="col-span-1 space-y-0.5">
          <div className="text-[11px] 2xl:text-xs uppercase leading-none text-slate-400 tracking-wide">
            Number of Files
          </div>
          <div className="text-sm 2xl:text-base font-medium leading-none">
            {data?.items?.length}
          </div>
        </div>
        <div className="col-span-1 space-y-0.5">
          <div className="text-[11px] 2xl:text-xs uppercase leading-none text-slate-400 tracking-wide">
            Order Date
          </div>
          <div className="text-sm 2xl:text-base font-medium leading-none">
            {dayjs(data?.createdAt).format("D MMMM, YYYY")}
          </div>
        </div>
        <div className="col-span-1 space-y-0.5 flex flex-col items-end text-right">
          <div className="text-[11px] 2xl:text-xs uppercase leading-none text-slate-400 tracking-wide">
            Order Status
          </div>
          <div
            className="text-sm 2xl:text-base font-semibold inline-block leading-none"
            style={{ color: "var(--statusHexColorMap)" }}
          >
            {data?.status && (
              <div
                className="relative text-[10px] inline-flex items-center gap-x-1 leading-none uppercase py-1 px-1 rounded-full tracking-widest font-semibold"
                style={{ color: "var(--statusColor)" }}
              >
                <div
                  className="absolute top-0 left-0 w-full h-full rounded-xl opacity-10"
                  style={{ backgroundColor: "var(--statusColor)" }}
                />
                <div
                  className="absolute top-0 left-0 w-full h-full rounded-xl border opacity-10"
                  style={{ borderColor: "var(--statusColor)" }}
                />
                <div
                  className="w-3 h-3 rounded-full animate-pulse"
                  style={{ backgroundColor: "var(--statusColor)" }}
                />
                <span className="px-1">{data?.status}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default OrderItem;
